<template>
  <v-layout :column="column" mb-2>
    <v-flex :class="titleClass" class="title">
      <h4 class="pt-2 subheading grey--text text--darken-2">
        {{ label }}
        <v-tooltip v-if="tooltipMessage" top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small color="primary">info</v-icon>
          </template>
          <span style="white-space: pre-line">{{ tooltipMessage }}</span>
        </v-tooltip>
        <span v-if="caution" class="caution-message"> ※{{ caution }} </span>
      </h4>
    </v-flex>
    <v-flex :class="slotClass">
      <slot />
      <p :class="hintClass">{{ hint }}</p>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'AppForm',
  props: {
    label: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    caution: {
      type: String,
      default: '',
    },
    titleWidth: {
      type: Number,
      default: 2,
    },
    singleSpan: {
      type: Boolean,
      default: false,
    },
    column: Boolean,
    tooltipMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    titleClass() {
      return ['xs' + this.titleWidth, this.column ? 'mb-2' : undefined]
    },
    slotClass() {
      const result = ['xs' + (12 - this.titleWidth)]
      if (this.singleSpan) result.push('single-span')
      return result
    },
    hintClass() {
      return {
        hint: true,
        'caution-text': this.caution,
      }
    },
  },
}
</script>

<style scoped>
.v-input {
  padding: 0;
  margin: 0;
}
.caution-text {
  color: red;
}
.title {
  min-width: 200px;
}
.hint {
  margin: 0;
}
.single-span {
  line-height: 20px;
  padding-top: 4px;
}
.caution-message {
  color: red;
  font-size: 11px;
  margin-left: 5px;
}
</style>
